import GlobalServicesForm from './components/GlobalServicesForm'
import GlobalServicesTable from './components/GlobalServicesTable'
import { useGlobalServices } from './hooks/useGlobalServices'

const GlobalServicesWrapper = () => {
  const {
    facet,
    setFacet,
    page,
    setPage,
    pageSize,
    setPageSize,
    filter,
    services,
    debouncedGetServices,
    deleteRecord,
    editRecord,
    addRecord,
    currentRecord,
    getServices,
    handleGlobalServicesApi,
    loading,
    formLoading,
    handleAddFilterChange
  } = useGlobalServices()

  switch (facet) {
    case 1:
      return (
        <GlobalServicesTable
          services={services}
          editRecord={editRecord}
          addRecord={addRecord}
          deleteRecord={deleteRecord}
          refreshView={getServices}
          loading={loading}
          debouncedGetServices={debouncedGetServices}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          handleAddFilterChange={handleAddFilterChange}
        />
      )
    case 2:
      return (
        <GlobalServicesForm
          currentRecord={currentRecord}
          handleGlobalServicesApi={handleGlobalServicesApi}
          setFacet={setFacet}
          formLoading={formLoading}
        />
      )

    default:
      return (
        <div
          style={{
            textAlign: 'center',
            padding: '50px',
            fontSize: '18px',
            color: '#666'
          }}
        >
          No facet selected. Please refresh the page.
        </div>
      )
  }
}

export default GlobalServicesWrapper
